import React, { Component } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { connect } from 'react-redux';
import {
	BRANCH_ACCESS,
	COMPANY_ACCESS
} from '../../../constants/general';
import { ADMIN_OWNER } from '../../../constants/bitwiseOperations';
import { fetchCompanyBranches, updateSelectedBranch } from '../../../store/actions/branches/branchActions';
import { Debouncer } from '../../../utils/debouncer';

class SearchBranchSelect extends Component {
	
	constructor(props) {
		super(props);
		let { session, branch, fromReports, largerInput } = this.props;
	    this.state = {
			isLoading:false,
			openSearcher:this.props.branch && this.props.branch.id ? true : false,
			selected:"",
			fromReports: fromReports ? true : false,
			largerInput: largerInput ? true : false, 
			typingTimeout:300,
			userBranches: session && session.accesses ? session.accesses.filter(e => e.access_type === "branch" && e.id !== String(branch.id)).concat({access_id:null,related_access: {id:null,name:'Todos Los comercios'}}) : []
		}
	}

	componentDidUpdate(prevProps){
		let newList = [];
		let { branches, userHigherAccess, session,branch } = this.props;
		if (prevProps.branches !== branches && userHigherAccess > BRANCH_ACCESS) {
			// los usuarios al loguearse les llega el modelo de Access no el del Branch directamente, entonces como es mas frecuente q se
			// loguee un usario tipo branch a uno tipo company, le agrego la estructura basica q necesito para q un modelo Branch se parezca a un
			// modelo Access, es decir,
			// es distinto lo q esta guardado en this.props.session.access a lo q esta en this.props.branches
			if (userHigherAccess === COMPANY_ACCESS || session.account.type === ADMIN_OWNER){
				if( branches.length > 0 ){
					if(this.props.branchGruopIds && this.props.branchGruopIds.length > 0){
						newList = branches.filter(branch => this.props.branchGruopIds.includes(branch.branch_group_id)).map(b => { return { access_id: b.id, related_access: {...b} } })
					}else{
						newList = branches.map(b => { return { access_id: b.id, related_access: {...b} } })
					}
				}
				this.setState({ userBranches: newList });
			}
			else {
				newList = this.props.branches.map(b => {
					let finded = this.state.userBranches.findIndex(ub => ub.access_type === "branch" && ub.access_id === b.id)

					return finded !== -1 ? { access_id: b.id, related_access: {...b} } : null;
				}).filter( b => b)// devuelve los que no son nulos
			}
			newList = newList.concat({access_id:-1,related_access: {id:-1,name:'Todos Los comercios'}})
		}
		if(prevProps.branch.id !== branch.id){
			this.setState({openSearcher:this.props.openSearcher ? this.props.openSearcher : true })
		}
	}

	debouncer = new Debouncer();

	SearchAction(query){
		let { userHigherAccess } = this.props;
		this.setState({isLoading: true})
		
		if(userHigherAccess > BRANCH_ACCESS && query){
			this.debouncer.debounce(() => {
				this.props.fetchCompanyBranches(10,query).then(() => {
					this.setState({ isLoading: false })
				})
				.catch((err) => {
					this.setState({ isLoading: false })
				})
			})
		}
	}

	clearform(){
		this.setState({openSearcher:false})
		this._typeahead.getInstance().clear();
		this.props.clear ? this.props.clear() : null
	}

	setBranch = (branch) => {
		this.props.updateSelectedBranch(branch ? branch : {}).then(() => this._typeahead.getInstance().clear());
	}

	find(){
		let { userHigherAccess } = this.props;
		
		if((userHigherAccess > BRANCH_ACCESS ) && this.state.openSearcher === false){
			this.props.fetchCompanyBranches().then(() => {
				this.setState({ isLoading: false })
			})
			.catch((err) => {
				this.setState({ isLoading: false })
			})
		}
		this.setState({openSearcher:true,isLoading: true})
	}
	render () {
		let { company,userHigherAccess,session } = this.props;
		return (
			<div style={{display: 'flex'}}>
				{
					userHigherAccess === COMPANY_ACCESS || session.account.type === ADMIN_OWNER ?
					this.props.noClear === true ? '' :
					<div className={`custon_tap ${this.state.openSearcher === false ? 'custon_active_tab' :''}`} onClick={()=> this.clearform()} style={{padding: `0 5px 0 0`,display:'flex', gap:'10px',alignItems: 'center',cursor:"pointer"}} title={company.name}>
						{	
						this.state.fromReports ?
							<span className='mx-2'>
								Limpiar filtro
							</span> 
						:
							<React.Fragment>
								<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" style={this.state.openSearcher === false ? {fill: `white`} : {}}>
									<path d="M201-120q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518v318q0 33-23.5 56.5T761-120H201Zm368-440q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z"/>
								</svg>
								<span>
									Todos los comercios
								</span>
							</React.Fragment>
						}
					</div>
					:null
				}
				
				<div className={`custon_tap ${this.state.openSearcher === true ?'custon_active_tab' :''} ${this.state.largerInput ? "custom-larger-input" : ""}`} onClick={()=>this.find()} style={{
					borderRight: 'none',
					borderTop: 'none',
					borderBottom: 'none'
				}}>
					<AsyncTypeahead
						className={`header_tap`}
						ref={(ref) => this._typeahead = ref}
						labelKey="name"
						options={ this.state.userBranches.map($0 => $0.related_access)}
						onChange={this.props.change ? this.props.change : (e) => this.setBranch(e[0]) }
						//onBlur={()=> this.setState({openSearcher:this.props.openSearcher ? this.props.openSearcher : true})}
						onSearch={(query) => this.SearchAction(query)}
						isLoading={this.state.isLoading}
						value={this.state.selected}
						//defaultSelected={[this.state.selected]}
						placeholder={ this.props.placeholder ? this.props.placeholder : `Seleccione un comercio` } />
				</div>
			</div>
		)	
	}
}


const mapStateToProps = (state) => {
	//console.log("dashboard",state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing && state.dashboardStatistics.orders.ongoing.hanging)
	return {
		admin_type:state.session && state.session.admin_type && state.session.admin_type.name,
		admin_account_type:state.session && state.session.account && state.session.account.type,
		admin_type_id:state.session && state.session.admin_type && state.session.admin_type.id ? state.session.admin_type.id : "",
		company:state.company,
		userHigherAccess: state.userHigherAccess,
		branch:state.branch,
		branches: state.branches,
		session: state.session,
		unseenNotifications: state.unseenNotifications,
		errors: state.errors,
		online: state.userIsOnline,
		json_lang: state.json_lang,
		defaultDashboard:state.company.options,
		//statsCurrent: state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing,
		statsCurrent: state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing && state.dashboardStatistics.orders.ongoing.unattended,
		unconfirmedOrders: state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.unattended && state.dashboardStatistics.orders.unattended.unconfirmed,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchCompanyBranches: (limit,query) => dispatch(fetchCompanyBranches(limit,query)),
		updateSelectedBranch: (userBranch) => dispatch(updateSelectedBranch(userBranch)), 
	}
}

export default connect(mapStateToProps , mapDispatchToProps)(SearchBranchSelect);


// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/SearchBranchSelect.js